import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { motion } from 'framer-motion';
const stepVariant = {
    hide: { opacity: 0, y: 10 },
    show: { opacity: 1, y: 0 },
};
export default function StepListItem({ children, className, disabled, onClick, }) {
    return (_jsx(motion.button, { type: "button", variants: stepVariant, disabled: disabled, className: classNames('hover:bg-accent focus-visible:bg-accent focus-visible:outline-primary flex w-full cursor-pointer items-center justify-between gap-1 px-6 py-5 transition-all focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2', className), onClick: onClick, "data-testid": "step-list-item", children: children }));
}
